import {
  SamplesManagementActionTypes,
  SET_CENTRE_LEARNERS,
  SET_ERROR,
  SET_IS_SAMPLE_LOADING,
  SET_SAMPLE,
  SET_IS_ENTRIES_PATCHING,
  SET_CONSORTIUM_DATA,
  SET_IS_ENTRIES_LOADING,
  SET_SAMPLE_SEARCH_PARAMS,
  RESET_STATE,
  RESET_STATE_FULL,
  SET_IS_SAMPLE_BEING_RERUN,
  SET_ALGO_RERUNS,
} from './types';
import { SamplesManagementState } from '../../types/SamplesManagement';
import { GlobalActionTypes } from '../types';
import { unknown } from '../actions';

export const initialState: SamplesManagementState = {
  sample: undefined,
  isSampleLoading: false,
  isEntriesPatching: undefined,
  hasError: false,
  isEntriesLoading: false,
  centreLearners: [],
  sampleSearchParams: undefined,
  consortium: undefined,
  newLearners: [],
  isSampleBeingRerun: undefined,
  algoReruns: [],
};

export default (
  state = initialState,
  action: SamplesManagementActionTypes | GlobalActionTypes = unknown(),
): SamplesManagementState => {
  switch (action.type) {
    case SET_CONSORTIUM_DATA: {
      const {
        payload: { consortium },
      } = action;

      return { ...state, consortium };
    }

    case SET_ALGO_RERUNS: {
      const {
        payload: { algoReruns },
      } = action;

      return { ...state, algoReruns };
    }

    case RESET_STATE: {
      return { ...initialState, sampleSearchParams: state.sampleSearchParams };
    }

    case RESET_STATE_FULL: {
      return { ...initialState };
    }

    case SET_SAMPLE_SEARCH_PARAMS: {
      const {
        payload: { sampleSearchParams },
      } = action;

      return { ...state, sampleSearchParams };
    }

    case SET_IS_SAMPLE_LOADING: {
      const {
        payload: { value },
      } = action;

      return { ...state, isSampleLoading: value };
    }

    case SET_IS_ENTRIES_LOADING: {
      const {
        payload: { value },
      } = action;

      return { ...state, isEntriesLoading: value };
    }

    case SET_IS_SAMPLE_BEING_RERUN: {
      const {
        payload: { value },
      } = action;

      return { ...state, isSampleBeingRerun: value };
    }

    case SET_IS_ENTRIES_PATCHING: {
      const {
        payload: { value },
      } = action;

      return { ...state, isEntriesPatching: value };
    }

    case SET_CENTRE_LEARNERS: {
      const {
        payload: { centreLearners },
      } = action;
      return { ...state, centreLearners };
    }

    case SET_SAMPLE: {
      const {
        payload: { sample },
      } = action;
      return {
        ...state,
        sample: {
          ...sample,
          wholeSample:
            sample.wholeSample.length > 0 ? sample.wholeSample.sort((a, b) => Number(b.mark) - Number(a.mark)) : [],
        },
      };
    }

    case SET_ERROR: {
      return {
        ...state,
        hasError: true,
        isSampleLoading: false,
      };
    }

    default:
      return state;
  }
};
